module.exports = __webpack_public_path__ + "img/9.dc05e6b6.png";